/**
 * 时间展示（学员端统一口径）
 * -----------------------------------------------------------------------------
 * 服务端下发的时间一律是 ISO 字符串（`2026-10-03T09:12:00.000Z`），
 * 直接渲染会露出 `T` 与毫秒、时区尾巴 —— 界面上任何时间都必须过这里。
 *
 * 已经是「人类可读」形态的字符串（不含 `T` 的 `YYYY-MM-DD HH:mm`）原样返回，
 * 这样同一份 mock / 历史数据不会因为再解析一次而错位。
 */

const ISO_LIKE = /^\d{4}-\d{2}-\d{2}T/;

function pad2(value: number): string {
  return String(value).padStart(2, '0');
}

/** ISO 时间 → `2026-10-03 09:12`；空值给空串，无法识别时原样返回 */
export function formatDateTime(input: string | null | undefined): string {
  if (!input) return '';
  if (!ISO_LIKE.test(input)) return input;
  const date = new Date(input);
  if (Number.isNaN(date.getTime())) return input;
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())} ${pad2(
    date.getHours(),
  )}:${pad2(date.getMinutes())}`;
}
